import { ImperativeDialogContext } from "@repo/ui";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { configurationApi } from "~/api";

export const useGetChoiceUsage = (workflowId: number | null, fieldId: number | null) => {
  const queryClient = useQueryClient();
  const dialogContext = useContext(ImperativeDialogContext);
  const { showDialog, closeDialog } = dialogContext ?? {};

  const getChoiceUsage = async (choice: string): Promise<boolean> => {
    if (workflowId === null || fieldId === null) return true;

    let usage: Record<string, boolean>;
    try {
      usage = await queryClient.fetchQuery(
        configurationApi.queryOptions(
          "get",
          "/api/workflow/{workflowId}/Field/{fieldId}/options/usage",
          { params: { path: { workflowId, fieldId } } }
        )
      );
    } catch {
      return false;
    }

    if (!usage[choice]) return true;

    return new Promise<boolean>((resolve) => {
      if (!showDialog || !closeDialog) {
        resolve(true);
        return;
      }
      showDialog({
        title: "Choice in use",
        description: `"${choice}" is currently used by one or more items. Remove anyway?`,
        confirmText: "Remove",
        confirmVariant: "destructive",
        cancelText: "Cancel",
        cancelVariant: "outline",
        disableXClose: true,
        onConfirm: () => {
          closeDialog();
          resolve(true);
        },
        onCancel: () => {
          closeDialog();
          resolve(false);
        },
      });
    });
  };

  return getChoiceUsage;
};
